import React from 'react';
import PropTypes from 'prop-types';
import { useGetTheme } from '../../../../hooks/useGetTheme';
import s from '../column-title.module.scss';

const ColumnTotalStakedAmount = ({ isMobile }) => {
  const colors = useGetTheme();
  const getTextColor = () => ({ style: { color: colors.text } });

  if (isMobile) {
    return (
      <div className={s.colTitle} {...getTextColor()}>
        Total Staked Amount
      </div>
    );
  }

  return (
    <div>
      <span {...getTextColor()} className={s.title}>
        Total Staked Amount
      </span>
    </div>
  );
};

ColumnTotalStakedAmount.propTypes = {
  isMobile: PropTypes.bool,
};

ColumnTotalStakedAmount.defaultProps = {
  isMobile: false,
};

export default ColumnTotalStakedAmount;
